import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const mask = createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 2,
    requireDecimal: false,
    allowNegative: false,
    allowLeadingZeroes: false,
    integerLimit: null,
});

export default {
    mask: mask,
    guide: false,
    keepCharPositions: false,
    placeholderChar: '\u2000',
};
